import { FrequencyMode, FrequencyPeriod } from 'modules/frequencyManagement/lib/types';

export const LABEL_BY_PERIOD: Record<FrequencyPeriod, string> = {
  /** NOTE: Update these to use standardized i18n patterns */
  [FrequencyPeriod.Daily]: 'day',
  [FrequencyPeriod.Weekly]: 'week',
  [FrequencyPeriod.Monthly]: 'month',
};

export const LABEL_BY_FREQUENCY_MODE: Record<FrequencyMode, string> = {
  /** NOTE: Update these to use standardized i18n patterns */
  [FrequencyMode.Off]: 'Off',
  [FrequencyMode.NoCap]: 'No cap',
  [FrequencyMode.Cap]: 'Fixed cap',
  [FrequencyMode.Optimize]: 'Optimize',
};

export const SummaryBannerNameLimit = 10;
export const OptimizeModeLimit = 10;

export const NavTitle = 'Frequency Management';

export const FrequencyManagementUrl = `/settings/frequencyManagement/`;

export const OptimizeIconId = 'frequency-optimize-icon';

export const BANNER_MANAGEMENT_SETTINGS_LINK = 'Manage configuration';

export const BANNER_MANAGEMENT_SETTINGS_ERROR =
  'Oops! We are having trouble retrieving this information';
